<template>
  <div class="root-content search-results">
    <div class="content-wrapper" style="max-height: calc(100vh - 76px);">
      <div class="search-results__empty" v-if="noResults">
        <Lottie
          :path="notFoundAnimation"
          :loop="true"
          :autoPlay="true"
          :width="256"
          :height="256"
        />
        <div class="acr-bold-22 search-results__empty-title">
          None of your videos, projects <br> or detections matched this search
        </div>
        <div class="acr-regular">Make sure that all words are spelled correctly <br> or try different keywords</div>
      </div>
      <div class="projects-table search-results__projects" v-if="searchResults.projects.projects.length > 0">
        <div class="projects-table-item projects-table-item--heading" style="padding-top: 0;box-shadow: none">
          <div class="projects-add-project">
            <span class="acr-bold-22">Projects</span>
          </div>
          <div class="projects-info acr-bold-18" >
            <div class="projects-title">Status</div>
            <div class="projects-title">Created</div>
            <div class="projects-title">Modified</div>
          </div>
          <div class="projects-btn">
            <svgicon name="Filter" style="width: 19px;height: 19px;"></svgicon>
          </div>
        </div>
        <div class="projects-table-item" v-for="project in searchResults.projects.projects" :key="project.id" @click="handleProjectClick(project)">
          <div class="projects-table-item__name">
            <svgicon name="Cut2" class="projects-table-item__icon" v-if="project.project_type === 'video_analytics'"></svgicon>
            <svgicon name="Bar-chart" class="projects-table-item__icon" v-else></svgicon>
            <span class="acr-bold">{{project.project_name}}</span>
          </div>
          <div class="projects-info acr-medium">
            <div class="projects-title acr-medium">
                      <span>
                        Completed
                      </span>
              <div class="projects-status">
                <svgicon name="Done"></svgicon>
              </div>
            </div>
            <div class="projects-title acr-medium">Aug 7, 2021</div>
            <div class="projects-title acr-medium">Aug 7, 2021</div>
          </div>
          <span style="transform: translateX(5px)">
                  <el-dropdown trigger="hover" >
                  <div class="projects-btn projects-btn--transparent">
                    <svgicon name="More"></svgicon>
                  </div>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item >Re-run</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                </span>

        </div>
      </div>
      <div class="search-results__videos" v-if="searchResults.objects.folders_data.folders.length > 0 || searchResults.objects.videos_data.videos.length > 0" style="padding: 21px 20px">
        <div class="acr-bold-22 search-results__title">Videos</div>
        <div class="files__folders" style="padding-top: 0">
          <div class="files__folder" v-for="folder in searchResults.objects.folders_data.folders" :key="folder.id" @click="handleFolderClick(folder)">
            <svgicon name="Folder2" class="files__folder-icon"></svgicon>
            <div style="margin-top: 6px">
              <div class="files__folder-title acr-bold">{{folder.folder_name}}</div>
              <div class="files__folder-info">{{folder.childs_ids ? folder.childs_ids.length + ' videos' : 'Folder is empty'}}</div>
            </div>
            <div class="files__folder-options">
              <el-dropdown trigger="hover">
                <svgicon name="More2"></svgicon>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item >Delete</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
        <div class="files__videos">
          <div class="files__video" v-for="video in searchResults.objects.videos_data.videos" :key="video.id">
            <div class="files__video-clickable" @click="handleVideoClick(video)"></div>
            <div class="files__video-overlay">
              <div class="files__video-options">
                <el-dropdown trigger="hover">
                  <svgicon name="More2"></svgicon>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item >Delete</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
              <div class="files__video-info">
                <div class="files__video-name">
                  <span class="acr-bold">{{video.display_name ? truncateString(video.display_name, 20) : truncateString(video.video_name, 20)}}</span>
                </div>
                <div class="files__video-date acr-regular">{{new Date(video.updated_at).toLocaleDateString("en-US", { year: 'numeric', month: 'long', day: 'numeric' })}}</div>
              </div>
            </div>
            <img :src="video.thumbnail_url" alt="" v-if="video.thumbnail_url && video.video_size" class="files__video-preview">
            <img src="../../assets/img/img-processing.png" class="files__video-preview" v-else/>
          </div>
        </div>
      </div>
      <div v-if="searchResults.tags.length" >
        <div class="search-results__detects" style="padding: 21px 20px;padding-bottom: 0" v-for="item in searchResults.tags" :key="item.id">
          <div class="acr-bold-22 search-results__title" style="display: flex;align-items: center;">
          <svgicon name="Cut2" class="projects-table-item__icon"></svgicon>
          <span style="text-transform: capitalize">{{item.project_name}}</span>
          </div>
          <div class="video-cutting__content">
            <div class="video-cutting__card" v-for="tag in item.tags" :key="tag.id" @click="handleTagClick(tag)">
              <div class="video video-cutting__card-video">
                <div class="video-cutting__card-clickable" ></div>
                <div class="video-overlay">
                  <svgicon name="Play" class="video-play"></svgicon>
                </div>
                <img :src="tag.thumbnail_url" alt="" class="video-src">
              </div>
              <div class="video-cutting__card-info">
                <div class="video-cutting__card-header acr-ultra-bold"></div>
                <div class="video-cutting__card-timecode">
                  <span class="acr-ultra-bold" style="margin-right: 7px">{{formatSeconds(tag.video_duration_sec)}}</span>
                  <span class="acr-medium-18">[{{formatSeconds(tag.start_time)}} - {{formatSeconds(tag.end_time)}}]</span>
                </div>
                <div class="video-cutting__card-tags">
                  <div class="video-cutting__card-tag acr-medium" v-for="item in tag.tags" :key="item">{{item}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import { mapGetters } from 'vuex';
import { formatSeconds } from "../../utils/utils";
import Lottie from "../../components/Lottie";
import { notFoundAnimation } from "../../utils/lottie";

export default {
  name: "Search",
  components: {
    Lottie
  },
  computed: {
    ...mapGetters({
      searchResults: 'searchResults',
    }),
    notFoundAnimation: () => notFoundAnimation,
    noResults() {
      return this.searchResults.projects.length === 0
        && this.searchResults.tags.length === 0
        && this.searchResults.objects.folders_data.folders.length === 0
        && this.searchResults.objects.videos_data.videos.length === 0
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (vm.$store.getters['searchQuery'].length > 0) {
        next();
      } else {
        next('/dashboard');
      }
    });
  },
  methods: {
    truncateString(str, num) {
      if (str.length > num) {
        return str.slice(0, num) + "...";
      } else {
        return str;
      }
    },
    formatSeconds(s) {
      return formatSeconds(s);
    },
    handleProjectClick(item) {
      this.$store.commit('setSearchQuery', '');
      if (item.project_type === 'video_analytics') {
        this.$router.push({ name: 'video-cutting', params: { projectId: item.id }})
      } else {
        this.$router.push({ name: 'project', params: { projectId: item.id }})
      }
    },
    handleVideoClick(item) {
      this.$store.commit('setSearchQuery', '');
      this.$router.push({ name: 'video', params: { videoId: item.id }})
    },
    handleFolderClick(item) {
      this.$store.commit('setSearchQuery', '');
      this.$router.replace({ name: 'dashboard', params: {folderId: item.id}}).catch(()=>{});
    },
    handleTagClick(tag) {
      this.$router.push({
        name: 'frame-view',
        params: {
          projectId: tag.project_id,
          videoId: tag.id,
          type: 'video_analytics',
          clipIndex: 0
        }
      })
    }
  },
}
</script>

<style scoped>

</style>
